import FilterInputs from './FilterInputs';

export default FilterInputs;
